export default __webpack_public_path__ + "static/media/affiliated_company_management.cd1d7017.png";